"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _errormessages = _interopRequireDefault(require("./errormessages"));

var _customizr = require("../services/customizr");

var getUserContext = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var ucnId, accessToken, context, status, errorToSurface;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ucnId = _ref.ucnId, accessToken = _ref.accessToken;
            _context.prev = 1;
            _context.next = 4;
            return (0, _customizr.getUserSettings)({
              accessToken: accessToken,
              contextId: ucnId
            });

          case 4:
            context = _context.sent;
            return _context.abrupt("return", {
              context: context
            });

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            status = _context.t0.response.status;
            errorToSurface = {
              contextId: ucnId,
              serverError: _context.t0
            };
            _context.t1 = status;
            _context.next = _context.t1 === 401 ? 15 : _context.t1 === 403 ? 17 : _context.t1 === 404 ? 19 : 21;
            break;

          case 15:
            errorToSurface.message = _errormessages["default"].unauthorized;
            return _context.abrupt("break", 22);

          case 17:
            errorToSurface.message = _errormessages["default"].forbidden.get;
            return _context.abrupt("break", 22);

          case 19:
            errorToSurface.message = _errormessages["default"].notFound;
            return _context.abrupt("break", 22);

          case 21:
            errorToSurface.message = "".concat(_errormessages["default"].serviceError.get, " ").concat(_errormessages["default"].contactMessage);

          case 22:
            return _context.abrupt("return", {
              error: errorToSurface
            });

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function getUserContext(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _default = getUserContext;
exports["default"] = _default;